import { createAsyncThunk } from "@reduxjs/toolkit";
import CurrencyRatesService from "../../../api/CurrencyRatesService";

export const asyncGetCurrencyRatesAction = createAsyncThunk(
    "currencyRates/all",
    async (_, thunkAPI) => {
        try {
            const response = await CurrencyRatesService.findAll();
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncGetCurrencyRateAction = createAsyncThunk(
    "currencyRates/one",
    async (id: number, thunkAPI) => {
        try {
            const response = await CurrencyRatesService.findOne(id);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncSaveAllCurrencyRatesAction = createAsyncThunk(
    "currencyRates/saveAll",
    async (formData: FormData, thunkAPI) => {
        try {
            const response = await CurrencyRatesService.saveAll(formData);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncGetOnlineBankingPercentAction = createAsyncThunk(
    "currencyRates/percent/onlineBanking/get",
    async (_, thunkAPI) => {
        try {
            const response = await CurrencyRatesService.findPercentByType("ONLINE_BANKING");
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncUpdateOnlineBankingPercentAction = createAsyncThunk(
    "currencyRates/percent/onlineBanking/update",
    async (value: string, thunkAPI) => {
        try {
            const response = await CurrencyRatesService.updatePercentByType("ONLINE_BANKING", { value });
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);